import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import storage from "redux-persist/lib/storage";
import { AuthState, authSlice } from "./slices/authSlice";
import { SystemState, systemSlice } from "./slices/systemSlice";
import { LookupListState, lookupListSlice } from "./slices/lookupListSlice";
import widgetsSlice, { WidgetsState } from "./slices/widgetSlice";
import attributesSlice, { AttributesState } from "./slices/attributesSlice";
import interactiveListSlice, {
  InteractiveListState,
} from "./slices/interactiveListSlice";

// Define the root state
export interface RootState {
  auth: AuthState;
  system: SystemState;
  lookupList: LookupListState;
  widgets: WidgetsState;
  attributes: AttributesState;
  interactiveList: InteractiveListState;
}

// Create a root reducer combining the counter slice and any other slices you may have
const rootReducer = combineReducers<RootState>({
  auth: authSlice.reducer,
  system: systemSlice.reducer,
  lookupList: lookupListSlice.reducer,
  widgets: widgetsSlice,
  attributes: attributesSlice,
  interactiveList: interactiveListSlice,
  // Add other slices here
});

// Configure persist options
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

// Create the Redux store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export default store;

// Infer the `AppDispatch` type from the store itself
export type AppDispatch = typeof store.dispatch;
